import type { FunctionComponent } from 'react';
import { Trans } from 'react-i18next';
import ConceptsBarItem from './ConceptsBarItem';
import Button from '../atoms/Button.Container';
import type { Season } from '../../data/Seasons';

export interface Props {
	season: Season;
	onConcepts?: () => void;
}

const NewConceptsBarItem: FunctionComponent<Props> = (props: Props) => {
	const { season, onConcepts } = props;

	return (
		<ConceptsBarItem season={season}>
			<Button
				onClick={onConcepts}
				width="100%"
				highlighted={!!onConcepts}
				highlightDelay="long"
			>
				<Trans>concepts_bar.choose</Trans>
			</Button>
		</ConceptsBarItem>
	);
};

export default NewConceptsBarItem;
